// extracted by mini-css-extract-plugin
export default {"wrapper":"PackModalContent_wrapper__QNUmJ","price":"PackModalContent_price__IxpKP","toprow":"PackModalContent_toprow__Fg9Rd"};